import React from "react";
import trans from "../../../../utils";

export default function PopupBodyItem({
  title,
  item,
  img,
  subitem,
  children,
  titlestyle,
  itemstyle,
}) {
  return (
    <>
      <div className="flex-between border-bottom popupbody-item">
        {img ? (
          <>
            <div className="fs-16 fw-400 neutral-400 text-capitalize">
              {trans(`${title} sensor support`)}
            </div>
            <div>
              <img src={`${process.env.PUBLIC_URL}/assets/${img}`} alt="" />
            </div>
          </>
        ) : (
          <>
            <div
              className={`fs-16 fw-400 neutral-400 text-capitalize ${titlestyle}`}
            >
              {title}
            </div>
            <div
              className={`fs-14 fw-500 text-capitalize ${itemstyle}`}
              title={subitem}
            >
              {item}
              {children}
            </div>
          </>
        )}
      </div>
    </>
  );
}
